import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { useState as A, useEffect as G } from "react";
import { FormLabel as K } from "../../../atoms/Form/FormLabel.es.js";
import { FormControl as N, chakra as X } from "@chakra-ui/react";
import { FormErrorMessage as _ } from "../../../atoms/Form/FormError.es.js";
import { Input as O } from "../../../atoms/Input/Input.container.es.js";
import { formatDate as p } from "../../../utils/date.es.js";
import { INPUT_VALUE_FORMAT as D } from "../DatePicker.constants.es.js";
import { useDatePickerContext as M, useDatePickerStyle as H } from "../DatePicker.context.es.js";
import { isValidDate as W } from "../DatePicker.utils.es.js";
import { CalendarIcon as j } from "../../../icons/index.es.js";
let b, B;
const Y = () => {
  const {
    customErrors: d,
    data: z,
    debounceDelay: y,
    errors: F,
    formikContext: a,
    getReferenceProps: T,
    isSmartData: g,
    isLoading: V,
    isError: P,
    onRetry: f,
    labels: [c],
    names: [u],
    onClear: C,
    onStartDateChange: L,
    onStartDateEnter: E,
    refs: k,
    setIsOpen: w,
    inputProps: I
  } = M(), S = H(), [r] = z.selectedDates, [n, i] = A(r ? p(r, D) : ""), v = (o) => {
    clearTimeout(b);
    const s = o.target.value;
    i(s), L(s), (W(s) || s === "") && (b = setTimeout(() => E(s), y));
  }, m = (o) => {
    o.code === "Space" && o.preventDefault();
  }, h = () => {
    clearTimeout(b), E(""), C();
  };
  G(() => {
    const o = r ? p(r, D) : "";
    i(o);
  }, [r]);
  const R = F[u] ?? (a == null ? void 0 : a.errors[u]) ?? d[u];
  return /* @__PURE__ */ x(N, { isInvalid: !!R, ref: k.setReference, children: [
    !!c && /* @__PURE__ */ e(K, { children: c }),
    /* @__PURE__ */ e(
      O,
      {
        disableFormik: !0,
        isFullWidth: !0,
        isSmartData: g,
        onChange: v,
        onClear: h,
        onFocus: () => w(!0),
        onKeyDown: m,
        rightAddon: n != null && n.length ? void 0 : /* @__PURE__ */ e(j, { boxSize: 4 }),
        size: "lg",
        isLoading: V,
        onRetry: f,
        variant: P && g ? "error" : void 0,
        sx: S.input,
        type: "date",
        value: n,
        ...I,
        ...T()
      }
    ),
    /* @__PURE__ */ e(_, { children: R })
  ] });
}, Z = () => {
  const {
    customErrors: d,
    data: z,
    debounceDelay: y,
    errors: F,
    formikContext: a,
    getReferenceProps: T,
    isSmartData: g,
    labels: [V, P],
    names: [f, c],
    onClear: u,
    onEndDateChange: C,
    onEndDateEnter: L,
    onStartDateChange: E,
    onStartDateEnter: k,
    refs: w,
    setIsOpen: I
  } = M(), S = H(), [r, n] = z.selectedDates, [i, v] = A(
    r ? p(r, D) : ""
  ), [m, h] = A(
    r ? p(n, D) : ""
  ), R = (l) => {
    clearTimeout(b);
    const t = l.target.value;
    v(t), E(t), (W(t) || t === "") && (b = setTimeout(() => k(t), y));
  }, o = (l) => {
    clearTimeout(B);
    const t = l.target.value;
    h(t), C(t), (W(t) || t === "") && (B = setTimeout(() => L(t), y));
  }, s = (l) => {
    l.code === "Space" && l.preventDefault();
  }, J = () => {
    v(""), E(""), h(""), C(""), u();
  }, Q = () => {
    h(""), C(""), u(!0);
  };
  G(() => {
    const l = r ? p(r, D) : "", t = n ? p(n, D) : "";
    v(l), h(t);
  }, [r, n]);
  const U = F[f] ?? (a == null ? void 0 : a.errors[f]) ?? d[f], q = F[c] ?? (a == null ? void 0 : a.errors[c]) ?? d[c];
  return /* @__PURE__ */ x(X.div, { __css: S.range, children: [
    /* @__PURE__ */ x(N, { isInvalid: !!U, ref: w.setReference, children: [
      !!V && /* @__PURE__ */ e(K, { children: V }),
      /* @__PURE__ */ e(
        O,
        {
          disableFormik: !0,
          isFullWidth: !0,
          isSmartData: g,
          onChange: R,
          onClear: J,
          onFocus: () => I(!0),
          rightAddon: i != null && i.length ? void 0 : /* @__PURE__ */ e(j, { boxSize: 4 }),
          size: "lg",
          sx: S.input,
          type: "date",
          value: i,
          ...T({
            onKeyDown: s
          })
        }
      ),
      /* @__PURE__ */ e(_, { children: U })
    ] }),
    /* @__PURE__ */ x(N, { isInvalid: !!q, children: [
      !!P && /* @__PURE__ */ e(K, { children: P }),
      /* @__PURE__ */ e(
        O,
        {
          disableFormik: !0,
          isFullWidth: !0,
          isSmartData: g,
          onChange: o,
          onClear: Q,
          onFocus: () => I(!0),
          rightAddon: m != null && m.length ? void 0 : /* @__PURE__ */ e(j, { boxSize: 4 }),
          size: "lg",
          sx: S.input,
          type: "date",
          value: m,
          ...T({
            onKeyDown: s
          })
        }
      ),
      /* @__PURE__ */ e(_, { children: q })
    ] })
  ] });
}, ce = () => {
  const { mode: d } = M();
  return d === "range" ? /* @__PURE__ */ e(Z, {}) : /* @__PURE__ */ e(Y, {});
};
export {
  ce as DatePickerControl
};
//# sourceMappingURL=DatePickerControl.es.js.map
